import React from 'react';
import reactCSS from 'reactcss';

import { Swatch } from 'react-color/lib/components/common';

export const CircleSwatch = ({ color, onClick, hover, active }) => {
    const circleSize = 20;
    const circleSpacing = 5;
    const styles = reactCSS(
        {
            default: {
                swatch: {
                    width: circleSize,
                    height: circleSize,
                    marginRight: circleSpacing,
                    marginBottom: circleSpacing,
                    transform: 'scale(1)',
                    transition: '100ms transform ease',
                },
                Swatch: {
                    borderRadius: '50%',
                    background: 'transparent',
                    boxShadow: `inset 0 0 0 ${circleSize / 2 + 1}px ${
                        color.color
                    }`,
                    transition: '100ms box-shadow ease',
                },
            },
            hover: {
                swatch: {
                    transform: 'scale(1.2)',
                },
            },
            active: {
                Swatch: {
                    boxShadow:
                        'inset 0 0 0 3px ' +
                        color.color +
                        ', inset 0 0 0 5px #000, inset 0 0 0 7px #fff',
                },
            },
        },
        {
            hover,
            active,
        }
    );

    return (
        <div style={styles.swatch}>
            <Swatch
                style={styles.Swatch}
                color={color.color}
                title={color.title}
                onClick={onClick}
            />
        </div>
    );
};

export default CircleSwatch;
